import React from 'react';
import cn from 'classnames';

import Img from 'components/presenters/Img/Img';

import CardContentRestrictedHook from '../CardRestrictedHook/CardRestrictedHook';

import styles from './CardInner.module.scss';

interface CardInnerProps {
  handleRef: (value: HTMLDivElement | null) => void;
  handleLinkRef: React.RefObject<HTMLAnchorElement>;
  isNoDataWithNoLogoImg: boolean;
  defaultImageUrl: string;
  name?: string;
  url?: string;
  contentOverlay: JSX.Element;
  cardType: string;
  isAdult?: boolean;
}

export const CardInner: React.FC<CardInnerProps> = ({
  url = '',
  name,
  handleRef,
  handleLinkRef,
  contentOverlay,
  defaultImageUrl,
  isNoDataWithNoLogoImg,
  cardType,
  isAdult,
}) => {

  return (
    <div tabIndex={-1} aria-hidden ref={handleRef} className={cn(styles.wrapper, styles[`type-${cardType}`])}>
      <div className={styles.inner}>
        <CardContentRestrictedHook handleLinkRef={handleLinkRef} isAdult={Boolean(isAdult)} />
        <div data-type='cardContent' className={styles.contentWrapper}>
          <div
            className={cn(styles.imageWrapper, {
              [styles.noDataWithDefaultImg]: isNoDataWithNoLogoImg,
            })}
          >
            <Img alt={name || cardType} src={url} fallbackImage={defaultImageUrl} />
          </div>
          <div className={styles.content}>{contentOverlay}</div>
        </div>
      </div>
    </div>
  );
};
